import type { ReactNode } from 'react';
import { cn } from '@/lib/ui-kit/utils';

interface SummaryRowProps {
  label: string;
  value: ReactNode;
  valueClassName?: string;
  interactive?: boolean;
}

/** A label/figure line of the popover's Prediction Markets and Crypto Trading tabs. */
export function SummaryRow({ label, value, valueClassName, interactive }: SummaryRowProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between py-1',
        interactive &&
          '-mx-2 rounded-md px-2 transition-colors hover:bg-v2-neutral-surface dark:hover:bg-v2-surface-tertiary',
      )}
    >
      <span className="text-[13px] leading-[1.5] text-v2-text-secondary">{label}</span>
      <span
        className={cn(
          'ph-no-capture text-[15px] font-semibold leading-5 tabular-nums text-v2-text-primary',
          valueClassName,
        )}
      >
        {value}
      </span>
    </div>
  );
}
